import { motion } from "framer-motion";

// Section-to-section connector: a vertical data channel with glowing
// packets drifting downward, framed by tick markers. Placed between
// sections to sell the "conveyor belt" continuity of the factory floor.
export default function SectionTransition({ label = "TRANSIT" }) {
  return (
    <div
      className="relative flex justify-center py-10 md:py-14"
      aria-hidden="true"
      data-testid="section-transition"
    >
      <div className="relative flex flex-col items-center gap-3">
        <div className="text-[9px] font-mono tracking-[0.32em] uppercase text-slate-500">
          {label}
        </div>
        <div className="relative w-px h-24 md:h-32 bg-black/10 overflow-hidden">
          {[0, 1, 2].map((i) => (
            <motion.span
              key={i}
              initial={{ y: -20, opacity: 0 }}
              whileInView={{ y: "120px", opacity: [0, 1, 1, 0] }}
              viewport={{ once: false, amount: 0.4 }}
              transition={{
                duration: 2.2,
                delay: i * 0.7,
                repeat: Infinity,
                ease: "linear",
              }}
              className="absolute left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-electric-500"
              style={{ boxShadow: "0 0 10px #00E5FF" }}
            />
          ))}
        </div>
        <div className="flex items-center gap-1.5 text-[9px] font-mono tracking-[0.22em] uppercase text-slate-600">
          <span className="w-1 h-1 rounded-full bg-electric-500/70" />
          <span>Continuous · Bonded · Authorized</span>
          <span className="w-1 h-1 rounded-full bg-electric-500/70" />
        </div>
      </div>
    </div>
  );
}
